/* 2 achetés, 1 offert : le 3e ensemble se met tout seul dans le panier.
   La cliente qui prend « 1 ensemble » puis appuie sur « + » (ou l'ajoute deux fois) arrive à 2 :
   on ajoute un 3e exemplaire de la même ligne (couleur et taille), et la remise automatique
   Shopify « Pack 2 achetés, 1 offert » (dès 3 ensembles) le rend gratuit.
   Si elle retire elle-même le 3e, on ne le remet pas : un bandeau lui propose de le reprendre.
   Écoute « hy:panier », envoyé par hy-panier.js à chaque affichage du tiroir.
   Réglages et textes : Paramètres du thème → COVALIE · Panier → 3e ensemble offert. */
(function () {
  var cfg = document.getElementById('cz-offert');
  if (!cfg) return;
  var PRODUIT = Number(cfg.getAttribute('data-produit')) || 0;
  var PAYES = Number(cfg.getAttribute('data-payes')) || 2;
  var AUTO = cfg.getAttribute('data-auto') === 'true';
  if (!PRODUIT) return;

  var CLE = 'cz-offert';
  var enCours = false;
  var derniereLigne = null;

  function lireMemo() {
    try { return JSON.parse(localStorage.getItem(CLE) || 'null') || {}; } catch (e) { return {}; }
  }
  function ecrireMemo(m) {
    try { localStorage.setItem(CLE, JSON.stringify(m)); } catch (e) {}
  }
  function texte(s) {
    var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML;
  }
  function surPagePanier() { return !!document.querySelector('cart-items'); }

  function poser(b, etat) {
    if (etat === 'ajoute') {
      b.innerHTML = '<p class="cz-offert__texte">' + texte(cfg.getAttribute('data-ajoute')) + '</p>';
      b.hidden = false;
    } else if (etat === 'propose') {
      b.innerHTML = '<p class="cz-offert__texte">' + texte(cfg.getAttribute('data-propose')) + '</p>' +
        '<button type="button" class="cz-offert__bouton" data-cz-offert-ajouter>' + texte(cfg.getAttribute('data-bouton')) + '</button>';
      b.hidden = false;
    } else {
      b.hidden = true;
      b.innerHTML = '';
    }
  }
  function creer() {
    var b = document.createElement('div');
    b.className = 'cz-offert';
    b.setAttribute('data-cz-offert', '');
    return b;
  }

  function bandeau(etat) {
    var tiroir = document.getElementById('hy-tiroir');
    if (tiroir) {
      var b = tiroir.querySelector('[data-cz-offert]');
      var liste = tiroir.querySelector('[data-hy-lignes]');
      if (!b && liste) { b = creer(); liste.parentNode.insertBefore(b, liste); }
      if (b) poser(b, etat);
    }
    /* Page « Votre panier » (/cart) : le même bandeau, entre la jauge et les articles (05/10/2026).
       Avant, il n'allait que dans le tiroir, fermé sur cette page : la cliente ne le voyait pas. */
    var page = surPagePanier() ? document.querySelector('cart-items') : null;
    if (page) {
      var bp = page.querySelector('[data-cz-offert-page]');
      var formulaire = page.querySelector('form#cart');
      if (!bp && formulaire) { bp = creer(); bp.setAttribute('data-cz-offert-page', ''); formulaire.parentNode.insertBefore(bp, formulaire); }
      if (bp) poser(bp, etat);
    }
  }

  function ajouterOffert(ligne) {
    if (enCours || !ligne) return;
    enCours = true;
    var item = { id: ligne.variant_id, quantity: 1 };
    var props = ligne.properties || {}, notes = {}, aNotes = false;
    for (var k in props) if (props[k] !== null && props[k] !== '') { notes[k] = props[k]; aNotes = true; }
    if (aNotes) item.properties = notes;
    var ok = false;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('ajout refusé');
      ok = true;
      var m = lireMemo(); m.offert = true; ecrireMemo(m);
    }).catch(function () {}).then(function () {
      enCours = false;
      if (ok && surPagePanier()) { window.location.reload(); return; }
      if (window.hyTiroirPanier) window.hyTiroirPanier.rafraichir();
    });
  }

  document.addEventListener('hy:panier', function (e) {
    var p = e.detail;
    if (!p || !p.items || enCours) return;
    var lignes = p.items.filter(function (a) { return a.product_id === PRODUIT && a.final_line_price > 0; });
    var n = lignes.reduce(function (s, a) { return s + a.quantity; }, 0);
    var m = lireMemo();
    var memePanier = m.token && m.token === p.token;
    var avant = memePanier && typeof m.n === 'number' ? m.n : null;
    var offert = !!(memePanier && m.offert && n === PAYES + 1);
    ecrireMemo({ token: p.token, n: n, offert: offert });
    derniereLigne = lignes[0] || null;

    if (n === PAYES) {
      /* arrivée à 2 en montant (1 → 2) : on ajoute le 3e ; arrivée en descendant (3 → 2) : on propose */
      if (AUTO && avant !== null && avant < PAYES) { bandeau(null); ajouterOffert(derniereLigne); return; }
      bandeau('propose');
      return;
    }
    bandeau(offert ? 'ajoute' : null);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cz-offert-ajouter]')) ajouterOffert(derniereLigne);
  });

  /* Page panier /cart : son script (Dawn) change la quantité par /cart/change sans prévenir le tiroir.
     Sur cette page seulement, on relit le panier après chacune de ses mises à jour. */
  if (surPagePanier() && window.fetch) {
    var fetchOrigine = window.fetch;
    window.fetch = function (ressource) {
      var reponse = fetchOrigine.apply(this, arguments);
      try {
        var adresse = String((ressource && ressource.url) || ressource);
        if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(adresse)) {
          reponse.then(function () {
            setTimeout(function () { if (window.hyTiroirPanier) window.hyTiroirPanier.rafraichir(); }, 300);
          }, function () {});
        }
      } catch (err) {}
      return reponse;
    };
  }
})();
